import React, { useEffect } from 'react';
import { Link, Outlet, useNavigate, useLocation, NavLink, Routes, Route } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Home, BarChart2, Users, Star, MoreHorizontal } from 'lucide-react';
import Teams from './Teams';
import AdminStaff from './AdminStaff';
import AdminArticles from './AdminArticles';

const navMain = [
  { to: '/', label: 'Accueil', icon: <Home size={22} /> },
  { to: '/stats', label: 'Stats', icon: <BarChart2 size={22} /> },
  { to: '/fanzone', label: 'Fan Zone', icon: <Star size={22} /> },
  { to: '/equipes', label: 'Equipes', icon: <Users size={22} /> },
  { to: '/plus', label: 'Plus', icon: <MoreHorizontal size={22} /> },
];

const Admin = () => {
  const { currentUser, userData } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!currentUser || !userData || userData.role !== 'admin') {
      navigate('/');
    }
  }, [currentUser, userData, navigate]);

  return (
    <div className="flex h-screen bg-[#001B56] text-white">
      {/* Sidebar */}
      <div className="w-64 flex flex-col justify-between bg-[#00238D] text-white p-4 pb-2">
        <div>
          <h2 className="text-2xl font-bold mb-6">Espace Admin</h2>
          {/* Section Equipes et Staff */}
          <nav>
            <ul className="space-y-2">
              <li>
                <Link to="/admin/teams" className={`block p-2 rounded ${location.pathname.includes('/admin/teams') ? 'bg-[#001B56]' : 'hover:bg-[#001B56]'}`}>Équipes</Link>
              </li>
              <li>
                <Link to="/admin/staff" className={`block p-2 rounded ${location.pathname.includes('/admin/staff') ? 'bg-[#001B56]' : 'hover:bg-[#001B56]'}`}>Staff</Link>
              </li>
            </ul>
          </nav>
          {/* Autres sections admin */}
          <nav className="mt-8">
            <ul className="space-y-2">
              <li>
                <Link to="/admin/matches" className={`block p-2 rounded ${location.pathname.includes('/admin/matches') ? 'bg-[#001B56]' : 'hover:bg-[#001B56]'}`}>Matchs</Link>
              </li>
              <li>
                <Link to="/admin/players" className={`block p-2 rounded ${location.pathname.includes('/admin/players') ? 'bg-[#001B56]' : 'hover:bg-[#001B56]'}`}>Joueurs</Link>
              </li>
              <li>
                <Link to="/admin/gallery" className={`block p-2 rounded ${location.pathname.includes('/admin/gallery') ? 'bg-[#001B56]' : 'hover:bg-[#001B56]'}`}>Galerie</Link>
              </li>
              <li>
                <Link to="/admin/quiz" className={`block p-2 rounded ${location.pathname.includes('/admin/quiz') ? 'bg-[#001B56]' : 'hover:bg-[#001B56]'}`}>Quiz</Link>
              </li>
              <li>
                <Link to="/admin/moderation" className={`block p-2 rounded ${location.pathname.includes('/admin/moderation') ? 'bg-[#001B56]' : 'hover:bg-[#001B56]'}`}>Modération</Link>
              </li>
              <li>
                <Link to="/admin/stats" className={`block p-2 rounded ${location.pathname.includes('/admin/stats') ? 'bg-[#001B56]' : 'hover:bg-[#001B56]'}`}>Statistiques</Link>
              </li>
              <li>
                <Link to="/admin/badges" className={`block p-2 rounded ${location.pathname.includes('/admin/badges') ? 'bg-[#001B56]' : 'hover:bg-[#001B56]'}`}>Badges</Link>
              </li>
              <li>
                <Link to="/admin/articles" className={`block p-2 rounded ${location.pathname.includes('/admin/articles') ? 'bg-[#001B56]' : 'hover:bg-[#001B56]'}`}>Articles</Link>
              </li>
              <li>
                <Link to="/admin/boutique" className={`block p-2 rounded ${location.pathname.includes('/admin/boutique') ? 'bg-[#001B56]' : 'hover:bg-[#001B56]'}`}>Boutique</Link>
              </li>
              <li>
                <Link to="/admin/users" className={`block p-2 rounded ${location.pathname.includes('/admin/users') ? 'bg-[#001B56]' : 'hover:bg-[#001B56]'}`}>Utilisateurs</Link>
              </li>
            </ul>
          </nav>
        </div>
        {/* Navigation principale en bas */}
        <nav className="mt-8">
          <ul className="flex flex-col gap-2">
            {navMain.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className="flex items-center gap-3 p-2 rounded hover:bg-[#001B56] transition">
                  {item.icon}
                  <span className="text-base font-semibold">{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      {/* Main content */}
      <div className="flex-1 p-8 bg-[#001B56] text-white overflow-y-auto">
        <Routes>
          <Route path="teams" element={<Teams />} />
          <Route path="staff" element={<AdminStaff />} />
          <Route path="articles" element={<AdminArticles />} />
        </Routes>
        <Outlet />
      </div>
    </div>
  );
};

export default Admin; 